// extracted by mini-css-extract-plugin
module.exports = {"list":"TemplatesList_list__3FYYT"};